import { render, staticRenderFns } from "./DashboardPage.vue?vue&type=template&id=3406811b&"
import script from "./DashboardPage.vue?vue&type=script&lang=ts&"
export * from "./DashboardPage.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports